export default {
  path: "/reviews",
  component: () => import("./index.vue"),
  name: "reviews",
  meta: {
    title: "reviews.title"
  }
}
